__webpack_require__.p = "/my_travel_journal/";